/* The hidden entrance state is set here, never in the markup, so a section this script never reaches cannot stay invisible. */
(() => {
  const FALLBACK_MS = 1200;

  const init = (root) => {
    if (root.dataset.bsReady) return;
    root.dataset.bsReady = 'true';

    if (root.dataset.bsAnimate !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.setAttribute('data-bs-reveal', '');

    let timer = 0;
    const show = () => {
      clearTimeout(timer);
      root.setAttribute('data-bs-reveal', 'in');
    };

    if (!('IntersectionObserver' in window)) {
      show();
      return;
    }

    timer = setTimeout(show, FALLBACK_MS);

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          show();
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    observer.observe(root);
  };

  const boot = () => document.querySelectorAll('[data-bronte-best-sellers]').forEach(init);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', boot);
})();
